var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgQuotes(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 33,
    height: 25,
    viewBox: "0 0 33 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "\xE2\x80\x9C",
    d: "M0.0859375 24.25V15.2393C0.0859375 10.9689 1.09661 7.5952 3.11797 5.11833C5.16779 2.64146 8.14288 1.01868 12.0432 0.25V4.69128C9.13932 5.60231 7.18914 7.16815 6.1927 9.38879C5.68024 10.556 5.46672 11.766 5.55213 13.0187H12.2568V24.25H0.0859375ZM32.2852 4.69128C29.4098 5.57384 27.4738 7.16815 26.4774 9.4742C25.908 10.6984 25.6802 11.8799 25.7941 13.0187H32.4987V24.25H20.3279V15.2393C20.3279 10.9119 21.3671 7.52402 23.4454 5.07562C25.5521 2.62722 28.4987 1.01868 32.2852 0.25V4.69128Z",
    fill: "#DEE4FF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgQuotes);
export default __webpack_public_path__ + "static/media/quotes.933bdb445ddd576335cbfd928e5335d1.svg";
export { ForwardRef as ReactComponent };